import { render } from "./TaskBody.vue?vue&type=template&id=370cbeee&scoped=true"
import script from "./TaskBody.vue?vue&type=script&lang=js"
export * from "./TaskBody.vue?vue&type=script&lang=js"

import "./TaskBody.vue?vue&type=style&index=0&id=370cbeee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370cbeee"]])

export default __exports__